import { gql } from '@apollo/client';
/**
 * @fragment LocationEmailFragment
 * @since 1.0.0
 */
export const LocationEmailFragment = gql `
  fragment LocationEmailFragment on LocationEmail {
    id
    type
    email
    primary
    createdAt
    updatedAt
  }
`;
